module.exports = __webpack_public_path__ + "media/images/products/products/j2-040e6c5f80d7cb753ae621d7cd53fd98.jpg";